import { useEffect, useState } from 'react'
import { toast } from '@/components/ui/use-toast'

const GlobalNotifications = () => {
  const [isConnected, setIsConnected] = useState(false)

  useEffect(() => {
    // Only proceed if Echo is available (Laravel Echo with broadcasting)
    if (typeof window.Echo === 'undefined') {
      console.log('Laravel Echo not available, using fallback polling for notifications')
      // Set up polling fallback
      setupPollingFallback()
      return
    }

    console.log('Setting up Laravel Echo for global notifications')

    // Listen for task creation notifications
    const channel = window.Echo.channel('notifications')
    
    channel
      .listen('.task.created.workflow', (event) => {
        console.log('Received task creation notification:', event)
        
        // Show toast notification
        toast({
          title: "🎯 Task Created",
          description: event.message,
          duration: 5000,
        })
      })
      .subscribed(() => {
        console.log('Successfully subscribed to notifications channel')
        setIsConnected(true)
      })
      .error((error) => {
        console.error('Error subscribing to notifications channel:', error)
        setIsConnected(false)
      })

    // Cleanup function
    return () => {
      if (window.Echo) {
        window.Echo.leaveChannel('notifications')
        console.log('Left notifications channel')
      }
    }
  }, [])

  // Fallback polling for when broadcasting is not available
  const setupPollingFallback = () => {
    let lastCheck = Date.now()
    
    const pollForNotifications = async () => {
      try {
        const response = await fetch(`/api/notifications/recent?since=${lastCheck}`, {
          headers: {
            'Accept': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
          }
        })
        
        if (response.ok) {
          const notifications = await response.json()
          
          notifications.forEach(notification => {
            if (notification.type === 'task.created.workflow') {
              toast({
                title: "🎯 Task Created",
                description: notification.message,
                duration: 5000,
              })
            }
          })
          
          lastCheck = Date.now()
        }
      } catch (error) {
        console.error('Error polling for notifications:', error)
      }
    }

    // Poll every 30 seconds
    const interval = setInterval(pollForNotifications, 30000)
    
    return () => clearInterval(interval)
  }

  // Component doesn't render anything visible - just handles notifications
  return null
}

export default GlobalNotifications 